import PropTypes from 'prop-types';
// import LazyLoad from 'react-lazyload';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import withPixelRatio from 'shared/hocs/withPixelRatio';

import s from './MakesItem.css';

class MakesItem extends Component {
  static propTypes = {
    setRatioImage: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    logo: PropTypes.string,
    link: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    models: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        id: PropTypes.number.isRequiredm,
      }),
    ),
  };

  static defaultProps = {
    models: [],
    logo: '',
    className: '',
  };

  handleLinkClick = link => {
    if (window) {
      window.open(link);
    }
  };

  render() {
    const { title, link, models, logo, className, setRatioImage } = this.props;

    return (
      <div className={className || s.makesItem}>
        <span onClick={() => this.handleLinkClick(link)}>
          {/*<LazyLoad offset={100}>*/}
          {/*<img*/}
          {/*  className={s.logo}*/}
          {/*  alt={title}*/}
          {/*  src={setRatioImage(logo, 30)}*/}
          {/*  width="30"*/}
          {/*  height="23"*/}
          {/*/>*/}
          {/*</LazyLoad>*/}
        </span>
        <div className={s.makeWithModels}>
          <span className={s.make} onClick={() => this.handleLinkClick(link)}>
            {title}
          </span>
          <p className={s.models}>
            {models.map(model => (
              <span
                key={model.id}
                className={s.model}
                onClick={() => this.handleLinkClick(model.link)}
              >
                {`${model.title}`}
              </span>
            ))}
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withPixelRatio(MakesItem));



// WEBPACK FOOTER //
// ./src/desktop/components/MakesSidebar/MakesItem/MakesItem.js